import PubSub from "underpub-js";
import Plyr from 'plyr/dist/plyr.polyfilled.js';

var VideoFullWidth = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-VideoFullWidth',
	};

	$.extend(true, this.options, options);

};

VideoFullWidth.prototype.init = function() {

	var self = this;

	this.$videoPlayerWrapper = self.options.$el.find(`.${self.options.baseClass}__videoPlayerWrapper`);
	var $videoPlayer = this.options.$el.find(`.${self.options.baseClass}__videoPlayer`);

	this.player = new Plyr( $videoPlayer, {
		enabled: true,
		controls: ['progress'],
		settings: ['captions', 'quality', 'speed', 'loop'],
		autoplay: false,
		muted: false,
		clickToPlay: true,
		hideControls: false,
		resetOnEnd: false,
		ratio: null, // The format is 'w:h' - e.g. '16:9' or '4:3'. HTML5 and Vimeo detect ratio automatically, youtube defaults to 16:9
	} );

	this.options.$el.find(`.${self.options.baseClass}__playButton`).on('click', function() {

		if ($(this).hasClass(`${self.options.baseClass}__playButton--playing`))
		{
			console.log('pause');
			self.player.pause();
		}
		else
		{
			console.log('play');
			self.player.play();
		}

	});

	this.$videoPlayerWrapper.on({
		mouseenter: function () {
			console.log('play');
			self.player.play();
		},
		// mouseleave: function () {
		// 	console.log('pause');
		// 	self.player.pause();
		// }
	});

	this.player.on('playing', event => {

		const instance = event.detail.plyr;
		
		self.options.$el.find(`.${self.options.baseClass}__playButton`).removeClass(`${self.options.baseClass}__playButton--paused`).addClass(`${self.options.baseClass}__playButton--playing`);

		self.options.$el.removeClass(`${self.options.baseClass}--paused`).addClass(`${self.options.baseClass}--playing`);

	});

	this.player.on('pause', event => {

		const instance = event.detail.plyr;
		
		self.options.$el.find(`.${self.options.baseClass}__playButton`).removeClass(`${self.options.baseClass}__playButton--playing`).addClass(`${self.options.baseClass}__playButton--paused`);

		self.options.$el.removeClass(`${self.options.baseClass}--playing`).addClass(`${self.options.baseClass}--paused`);

	});

};

export default VideoFullWidth;
